export default __webpack_public_path__ + "static/media/reg.0960ea24.png";